<template>
  <div class="countries-dropdown-wrapper">
    <md-field>
      <div @click="toggleDropdown()" class="dropdown-selected">
        <img :src="getFlagImage(countryLocal.code)" alt="country flag" class="flag">
        <label class="country-label">{{countryLocal.name}}</label>
      </div>
      <md-content v-if="dropdownOpen" class="dropdown-list md-scrollbar">
        <div v-for="country in countries" :key="country.code" :value="country" class="dropdown-list-item" @click="updateCountry(country)">
          <div class="country-container">
            <img class="flag" :src="getFlagImage(country.code)" alt="country flag">
            <label class="country-label">{{ country.name }}</label>
          </div>
        </div>
      </md-content>
    </md-field>
  </div>
</template>

<script>
import { COUNTRIES } from '@/configs/constants'

export default {
  name: 'CountriesDropdown',
  props: {
    value: {
      type: String,
      required: false,
      default: 'NG'
    }
  },
  data () {
    return {
      countryLocal: COUNTRIES[this.value.toUpperCase()],
      countries: COUNTRIES,
      dropdownOpen: false
    }
  },
  methods: {
    getFlagImage (countryCode) {
      return require(`@/assets/images/flags/${countryCode}.svg`)
    },
    updateCountry (country) {
      this.countryLocal = country
      this.$emit('input', this.countryLocal.code)
      this.$emit('change', this.countryLocal.code)
      this.toggleDropdown()
    },
    toggleDropdown () {
      this.dropdownOpen = !this.dropdownOpen
    }
  },
  mounted () {
    this.countries = COUNTRIES
    this.countryLocal = COUNTRIES[this.value.toUpperCase()]
  }
}
</script>

<style lang="sass" scoped>
.country-item
  display: flex
  justify-content: center
  align-items: center
  align-content: center
  margin-top: -20px
  img
    width: 25px
    height: 25px
  span
    margin-left: 20px

.dropdown-selected
  display: flex
  flex-direction: row
  width: 100%
  align-items: center
  cursor: pointer

.dropdown-list
  width: 180px
  height: 210px
  overflow: auto
  position: absolute
  top: 50px
  background: white
  box-shadow: 0 4px 6px 0 rgba(32,33,36,0.28)

.dropdown-list-item
  padding: 5px 0
  cursor: pointer

.dropdown-list-item:hover
  background: rgba(32,33,36,0.28)

.country-container
  display: flex
  flex-direction: row
  justify-content: space-around

  .flag
    width: 20px

.country-label
  position: relative
  top: 0
  width: 100px
  margin-left: 10px
</style>
